import {ActionContext, Module} from 'vuex'
import {RootState, WhatsAppState} from './state_models'
import to from "await-to-js";
import ConversationsService from "../services/ConversationsService";

export enum WHATSAPP_ACCESS_REQ_STATUS {
  PENDING = 'PENDING',
  FORM_SUBMITTED = 'FORM_SUBMITTED',
  APPROVED = 'APPROVED',
  APPROVED_AND_TERMS_ACCEPTED = 'APPROVED_AND_TERMS_ACCEPTED',
}

export enum WHATSAPP_NUMBER_STATUS {
  PENDING = 'PENDING',
  FORM_SUBMITTED = 'FORM_SUBMITTED',
  APPROVED = 'APPROVED'
}

export const whatsApp: Module<WhatsAppState, RootState> = {
  namespaced: true,
  state: {
    locationSetupDetails: {
      id: undefined,
      status: undefined,
      companyName: undefined,
      companyWebsite: undefined,
      companyEmail: undefined,
    },
    numbers: []
  },
  getters: {
    getLocationSetupDetails: (state: WhatsAppState) =>
      state.locationSetupDetails,
    getWhatsAppNumberStatus: (state: WhatsAppState) =>
      (number: string) => {
      const numberDetails = state.numbers.find((details)=> {
          return number === details.number
      })
      return numberDetails && numberDetails.status},
    whatsAppNumbers: (state: WhatsAppState) => state.numbers,
    approvedWhatsAppNumbers: (state: WhatsAppState) => {
      return state.numbers.filter(({status, disabled}) => status === WHATSAPP_NUMBER_STATUS.APPROVED && disabled !== true)
    }
  },
  mutations: {
    setLocationDetails: (state: WhatsAppState, data) => {
      const { id, status, companyName, companyWebsite, companyEmail } = data || {};
      state.locationSetupDetails = {
        id,
        status,
        companyName,
        companyWebsite,
        companyEmail
      }
    },
    setWhatsAppNumberDetails: (state: WhatsAppState, data) =>{
        const { status, id, number, displayName, logo, disabled = false} = data;

      const restOfTheNumbers = state.numbers.filter((details)=>{
        return details.number !== number
      })
      state.numbers = [
        ...restOfTheNumbers,
        {
          status, id, number, displayName, logo, disabled
        }
      ]
    },
    setNumbers: (state: WhatsAppState, numbers) => {
      state.numbers = numbers.map((details: any)=>{
        const {status, id, number, displayName, logo, disabled = false} = details
        return {status, id, number, displayName, logo, disabled}
      })
    },
  },
  actions: {
    async fetchLocationWhatsAppStatus ({commit}: ActionContext<WhatsAppState, RootState>, locationId: string) {
      const [error, response] = await to(ConversationsService.getWhatsAppLocationSetupStatus(locationId))
      if(!error){
        const whatsAppLocationSetupDetails = response?.whatsAppLocationSetupDetails
          commit('setLocationDetails', whatsAppLocationSetupDetails)
      }
    },
    async getWhatsAppNumbers ({commit}: ActionContext<WhatsAppState, RootState>, locationId) {
      const [error, response] = await to(ConversationsService.getWhatsAppNumbers(locationId))
      if(!error){
        const numbers = response?.numbers
        commit('setNumbers', numbers || [])
      }
    }
  },
}
